const dayjs = require( 'dayjs' );
const customParseFormat = require( 'dayjs/plugin/customParseFormat' );
const duration = require( 'dayjs/plugin/duration' );
const utc = require( 'dayjs/plugin/utc' );

dayjs.extend( customParseFormat );
dayjs.extend( duration );
dayjs.extend( utc );

let backUp = {
    hijri: [
        { date: 'Wrong Date  ', day: ' ' },
        { date: 'Wrong Date  ', day: ' ' },
        { date: 'Wrong Date  ', day: ' ' },
        { date: 'Wrong Date  ', day: ' ' },
        { date: 'Wrong Date  ', day: ' ' }
    ],
    hijriEn: [
        { date: 'Wrong Date  ', day: '' },
        { date: 'Wrong Date  ', day: '' },
        { date: 'Wrong Date  ', day: "" },
        { date: 'Wrong Date  ', day: '' },
        { date: 'Wrong Date  ', day: "" }
    ]
}

async function getPrayerTimeForNextWeekDinScreen ( theEntitiesProfiles ) {
    try {
        let date = new Date();

        let myWeek = [];
        let myDay = {};
        let d = dayjs( new Date() ).format( 'DD' );
        let m = dayjs( new Date() ).format( 'MM' );
        let day = ( Number( d ) )
        let month = ( Number( m ) - 1 );
        let first;

        let myFile = theEntitiesProfiles.prayerTimeYear;
        if ( myFile.length <= 12 ) {
            for ( let i = 0; i < 9; i++ ) {
                let newDateDay = ( ( dayjs( new Date() ).add( i, 'day' ) ) );
                day = Number( dayjs( newDateDay ).format( 'DD' ) - 1 );

                if ( i == 0 ) {
                    first = day;
                } else {
                    if ( first < day ) {
                    } else {
                        month = Number( dayjs( newDateDay ).format( 'MM' ) ) - 1;
                        first = day;
                    }
                }
                let apiPrayerTime = {}
                let iqamaTime = {}
                let tomorrowIqamaTime = {}

                if ( !myFile[ month ] || !myFile[ month ][ day ] ) {
                    continue;
                }

                let masjidDay = myFile[ month ][ day ];
                if ( masjidDay && masjidDay.adhanFajr ) {
                    apiPrayerTime.Fajr = await adhanCalcul( dayjs( masjidDay.adhanFajr, "hh:mm A" ).format( "HH:mm" ), theEntitiesProfiles.prayerTime.FautoA );
                    apiPrayerTime.Sunrise = dayjs( masjidDay.shourouk, "hh:mm A" ).format( "HH:mm" );
                    apiPrayerTime.Dhuhr = await adhanCalcul( dayjs( masjidDay.adhanDhuhr, "hh:mm A" ).format( "HH:mm" ), theEntitiesProfiles.prayerTime.DautoA );
                    apiPrayerTime.Asr = await adhanCalcul( dayjs( masjidDay.adhanAsr, "hh:mm A" ).format( "HH:mm" ), theEntitiesProfiles.prayerTime.AautoA );
                    apiPrayerTime.Maghrib = await adhanCalcul( dayjs( masjidDay.adhanMaghrib, "hh:mm A" ).format( "HH:mm" ), theEntitiesProfiles.prayerTime.MautoA );
                    apiPrayerTime.Isha = await adhanCalcul( dayjs( masjidDay.adhanIsha, "hh:mm A" ).format( "HH:mm" ), theEntitiesProfiles.prayerTime.IautoA );
                    apiPrayerTime.Imsak = await lastThirdNight( apiPrayerTime.Maghrib, apiPrayerTime.Fajr );
                    apiPrayerTime.Midnight = await midnight( apiPrayerTime.Maghrib, apiPrayerTime.Fajr );
                    myDay.apiPrayerTime = apiPrayerTime;

                    myDay.date = masjidDay.date

                    myDay.hijriDates = masjidDay.hijriDates || backUp;

                    iqamaTime.Fajr = await iqamaCalcul( theEntitiesProfiles.prayerTime.Fajr, theEntitiesProfiles.prayerTime.Fauto, myDay.apiPrayerTime.Fajr );
                    iqamaTime.Dhuhr = await iqamaCalcul( theEntitiesProfiles.prayerTime.Dhuhr, theEntitiesProfiles.prayerTime.Dauto, myDay.apiPrayerTime.Dhuhr );
                    iqamaTime.Asr = await iqamaCalcul( theEntitiesProfiles.prayerTime.Asr, theEntitiesProfiles.prayerTime.Aauto, myDay.apiPrayerTime.Asr );
                    iqamaTime.Maghrib = await iqamaCalcul( theEntitiesProfiles.prayerTime.Maghrib, theEntitiesProfiles.prayerTime.Mauto, myDay.apiPrayerTime.Maghrib );
                    iqamaTime.Isha = await iqamaCalcul( theEntitiesProfiles.prayerTime.Isha, theEntitiesProfiles.prayerTime.Iauto, myDay.apiPrayerTime.Isha );

                    myDay.iqamaTime = iqamaTime;

                    tomorrowIqamaTime.fIsDiff = false;
                    tomorrowIqamaTime.dIsDiff = false;
                    tomorrowIqamaTime.aIsDiff = false;
                    tomorrowIqamaTime.mIsDiff = false;
                    tomorrowIqamaTime.iIsDiff = false;

                    myDay.tomorrowIqamaTime = tomorrowIqamaTime;
                    myWeek.push( myDay );
                    myDay = {};
                }
            }

            theEntitiesProfiles.nextWeekPrayer = myWeek;
            return myWeek;
        }
    } catch ( error ) {
        console.log( error );
    }
}

async function getPrayerTimeForNextWeekProSettings ( theEntitiesProfiles ) {
    try {
        let date = new Date();
        let myWeek = [];
        let myDay = {};
        let myFile = theEntitiesProfiles.prayerTimeYear;

        for ( let ind = 0; ind < myFile.length; ind++ ) {
            if ( Array.isArray( myFile[ ind ] ) && myFile[ ind ].length > 0 ) {
                for ( let index = 0; index < myFile[ ind ].length; index++ ) {
                    const fileDate = dayjs( myFile[ ind ][ index ].date, "YYYY/MM/DD" );
                    const currentDate = dayjs( date );

                    if ( fileDate.format( "MM-DD" ) === currentDate.format( "MM-DD" ) ) {
                        for ( let i = 0; i < 9; i++ ) {
                            let currentInd = ind;
                            let currentIndex = index + i;

                            if ( currentIndex >= myFile[ currentInd ].length ) {
                                currentInd++;
                                currentIndex = currentIndex - myFile[ currentInd - 1 ].length;
                            }

                            if ( currentInd < myFile.length &&
                                myFile[ currentInd ] &&
                                myFile[ currentInd ][ currentIndex ] &&
                                myFile[ currentInd ][ currentIndex ].adhanFajr ) {

                                let apiPrayerTime = {};
                                let iqamaTime = {};
                                let tomorrowIqamaTime = {};
                                let currentDay = myFile[ currentInd ][ currentIndex ];

                                apiPrayerTime.Fajr = dayjs( currentDay.adhanFajr, "hh:mm A" ).format( "HH:mm" );
                                apiPrayerTime.Sunrise = dayjs( currentDay.shourouk, "hh:mm A" ).format( "HH:mm" );
                                apiPrayerTime.Dhuhr = dayjs( currentDay.adhanDhuhr, "hh:mm A" ).format( "HH:mm" );
                                apiPrayerTime.Asr = dayjs( currentDay.adhanAsr, "hh:mm A" ).format( "HH:mm" );
                                apiPrayerTime.Maghrib = dayjs( currentDay.adhanMaghrib, "hh:mm A" ).format( "HH:mm" );
                                apiPrayerTime.Isha = dayjs( currentDay.adhanIsha, "hh:mm A" ).format( "HH:mm" );
                                myDay.apiPrayerTime = apiPrayerTime;

                                apiPrayerTime.Imsak = await lastThirdNight( apiPrayerTime.Maghrib, apiPrayerTime.Fajr );
                                apiPrayerTime.Midnight = await midnight( apiPrayerTime.Maghrib, apiPrayerTime.Fajr );
                                myDay.date = currentDay.date;

                                myDay.hijriDates = currentDay.hijriDates || backUp;

                                iqamaTime.Fajr = dayjs( currentDay.iqamaFajr, "hh:mm A" ).format( "HH:mm" );
                                iqamaTime.Dhuhr = dayjs( currentDay.iqamaDhuhr, "hh:mm A" ).format( "HH:mm" );
                                iqamaTime.Asr = dayjs( currentDay.iqamaAsr, "hh:mm A" ).format( "HH:mm" );
                                iqamaTime.Maghrib = dayjs( currentDay.iqamaMaghrib, "hh:mm A" ).format( "HH:mm" );
                                iqamaTime.Isha = dayjs( currentDay.iqamaIsha, "hh:mm A" ).format( "HH:mm" );
                                iqamaTime.Jumua = dayjs( currentDay.Jumua1, "hh:mm A" ).format( "HH:mm" );
                                myDay.iqamaTime = iqamaTime;

                                tomorrowIqamaTime.fIsDiff = false;
                                tomorrowIqamaTime.dIsDiff = false;
                                tomorrowIqamaTime.aIsDiff = false;
                                tomorrowIqamaTime.mIsDiff = false;
                                tomorrowIqamaTime.iIsDiff = false;
                                myDay.tomorrowIqamaTime = tomorrowIqamaTime;

                                myWeek.push( { ...myDay } );
                                myDay = {};
                            }
                        }

                        theEntitiesProfiles.nextWeekPrayer = myWeek;
                        console.log( "--CSV--NEXT-WEEEK-DONE", myWeek );
                        return myWeek;
                    }
                }
            }
        }
    } catch ( error ) {
        console.log( error );
    }
}

async function nextWeekPrayerTimes ( theEntityProfiles, proSettings ) {
    try {
        let nextWeekPrayer = [];
        if ( proSettings ) {
            nextWeekPrayer = await getPrayerTimeForNextWeekProSettings( theEntityProfiles );
        } else {
            nextWeekPrayer = await getPrayerTimeForNextWeekDinScreen( theEntityProfiles );
        }
        return nextWeekPrayer;
    } catch ( e ) {
        console.log( e )
        return []
    }
}

async function iqamaCalcul ( iqama, addedTime, adhan ) {
    try {
        if ( Number( addedTime ) > 0 ) {
            let theIqama = dayjs( adhan, "hh:mm" );
            return theIqama.add( addedTime, "minutes" ).format( "HH:mm" )
        } else {
            return ( !iqama || iqama === "N/A" || iqama === '' ) ? adhan : iqama;
        }
    } catch ( error ) {
        return adhan
    }
};

async function adhanCalcul ( adhan, addedTime ) {
    try {
        if ( Number( addedTime ) !== 0 ) {
            let theAdhan = dayjs( adhan, "hh:mm" );
            return theAdhan.add( addedTime, "minutes" ).format( "HH:mm" )
        } else {
            return adhan;
        }
    } catch ( error ) {
        return adhan
    }
};

async function lastThirdNight ( maghrib, fajr ) {
    try {
        let begin = dayjs( maghrib, "hh:mm" );
        let end = dayjs( fajr, "hh:mm" );
        var duration = dayjs.duration( end.diff( dayjs( "00:00", "HH:mm" ) ) ).add( dayjs.duration( dayjs( "23:59", "HH:mm" ).diff( begin ) ) );
        var hours = duration.asHours();
        return end.subtract( ( hours / 3 ), "hours" ).format( "HH:mm" )
    } catch ( error ) {
        return "01:38"
    }
};

async function midnight ( maghrib, fajr ) {
    try {
        let begin = dayjs( maghrib, "hh:mm" );
        let end = dayjs( fajr, "hh:mm" );
        var duration = dayjs.duration( end.diff( dayjs( "00:00", "HH:mm a" ) ) ).add( dayjs.duration( dayjs( "23:59", "HH:mm a" ).diff( begin ) ) );
        var hours = duration.asHours();
        return end.subtract( ( hours / 2 ), "hours" ).format( "HH:mm" );
    } catch ( error ) {
        return "01:38"
    }
};

module.exports = {
    nextWeekPrayerTimes,
    iqamaCalcul,
    adhanCalcul,
    lastThirdNight,
    midnight
};